export default __webpack_public_path__ + "static/media/Construccion_Icon.3cb741a6.svg";